module.exports = "<ion-modal-view>\r\n    <ion-content delegate-handle=\"selectFileContent\"\r\n                 class=\"compose-add\">\r\n        <iframe name=\"cloudStorage\"\r\n                src=\"\"\r\n                frameborder=\"0\"\r\n                class=\"cloudStorage\"\r\n                id=\"cloudStorageModal\"></iframe>\r\n    </ion-content>\r\n</ion-modal-view>";


//////////////////
// WEBPACK FOOTER
// ./src/views/netFolder/cloudStorageModal.html
// module id = jcB1
// module chunks = 1